import type { Config, styleFn } from 'styled-system';
import { system } from 'styled-system';

import { addCustomProps } from './shouldForwardProp';

/**
 * Wrapper around Styled System's function for creating
 * custom style parsers.
 *
 * Use this instead of Styled System directly so we can
 * handle filtering props from being added as attributes
 * in the HTML output.
 *
 * @example
 * // Custom prop to set text decoration
 * const myProp = createCustomParser({
 *   textDecoration: true,
 * });
 *
 * // Usage
 * const MyBox = styled(Box)`
 *  ${myProp}
 * `;
 * <MyComp textDecoration="underline"/>
 *
 * @see https://styled-system.com/custom-props
 *
 * @param {object} configuration passed to Styled System's system function.
 * See the documentation at https://styled-system.com/custom-props.
 */
const createCustomParser: styleFn = (configuration: Config) => {
  // Create the custom parser
  const parser = system(configuration);
  // Add to prop names list
  if (parser.propNames != null) {
    addCustomProps(parser.propNames);
  }
  // Return the new parser
  return parser;
};

export default createCustomParser;
